import { graphql } from "gql.tada";
import { RichTextFragment } from "./fragments/RichTextFragment";
import { LinkFragment } from "./fragments/LinkFragment";

export const GetDefaultFooter = graphql(
  /* GraphQL */ `
    query GetDefaultFooter(
      $locale: String
      $preview: Boolean
      $allowedChildren: Int = 10
    ) {
      footerCollection(
        locale: $locale
        preview: $preview
        where: { singletonEnforcedString: "theoneandonlyfooter" }
        limit: 1
      ) {
        items {
          __typename
          newsletterFormLabel
          newsletterEmailFieldLabel
          newsletterCta
          newsletterSignUpInfoRichText {
            ...RichTextFragment
          }
          submissionApproved
          validEmailNote
          cookies
          linkGroupsCollection(limit: $allowedChildren) {
            items {
              title
              linksCollection(limit: $allowedChildren) {
                items {
                  ...LinkFragment
                }
              }
            }
          }
          copyright
          bottomLinkGroup {
            title
            linksCollection(limit: $allowedChildren) {
              items {
                ...LinkFragment
              }
            }
          }
          easterEggText
          mediaCollection(limit: $allowedChildren) {
            items {
              url
              contentType
            }
          }
        }
      }
    }
  `,
  [RichTextFragment, LinkFragment]
);
